export default "__VITE_ASSET__tg8d5MEB__"